import PropTypes from "prop-types";
import React from "react";
import "./style.css";
import { Recruit } from "../Recruit22";
import nacc_logo from "../../../static/img/NACC.png";
import issa_logo from "../../../static/img/ISSA.png";
import { NavLink } from "react-router-dom";

export const Footer = ({ footer}) => {
  return (
    <div className={`footer footer-${footer}`}>
      <div className="NAV">
         <div className="footer-main">
            <div className="LOGO">
            <a href="/" rel="noopener noreferrer">
              <Recruit className="recruit" recruitClassName="recruit-instance"/>
            </a>
            </div>
            <div className="MENU">
              <a className="text-wrapper-footer" href="https://www.linkedin.com/company/recruit22/" rel="noopener noreferrer" target="_blank">
                LinkedIn
              </a>
              <a className="text-wrapper-footer" href="https://www.dandelionphilosophy.com/" rel="noopener noreferrer" target="_blank">
                Philantropy
              </a>
              <a className="text-wrapper-footer" href="/talent#contactForm" rel="noopener noreferrer">
                Contact Us
              </a>
              <a className="text-wrapper-footer" href="/privacy" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </div>
            <div className="copyright">
              <p className="text-wrapper-copy">Copyright © 2025 Recruit22 LLC. All Rights Reserved.</p>
            </div>
          </div>
        
        <div className="footer-logos">
          <a href="https://www.naperville.net/" target="_blank">
          <img
                alt="nacc"
                src={nacc_logo}
                className="assoc-logo"
            />
          </a>
          <a href="https://issaworks.com/" target="_blank">
            <img
                alt="issa"
                src={issa_logo}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  footer: PropTypes.oneOf(["mobile", "default"]),
  href: PropTypes.string,
  href1: PropTypes.string,
  href2: PropTypes.string,
};
